"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const lodash_throttle_1 = __importDefault(require("lodash.throttle"));
const react_2 = require("@emotion/react");
function useWindowWidth() {
    const theme = (0, react_2.useTheme)();
    const [windowWidth, setWidth] = (0, react_1.useState)(0);
    (0, react_1.useLayoutEffect)(() => {
        // Ensure the hook runs only in client-side code
        if (typeof window !== 'undefined') {
            // Set initial width
            setWidth(window.innerWidth);
            const handleResize = (0, lodash_throttle_1.default)(() => {
                setWidth(window.innerWidth);
            }, 350);
            window.addEventListener('resize', handleResize);
            return () => {
                window.removeEventListener('resize', handleResize);
            };
        }
    }, []);
    return {
        windowWidth,
        aboveMd: windowWidth > parseInt(theme.db_screen_medium, 10)
    };
}
exports.default = useWindowWidth;
//# sourceMappingURL=useWindowWidth.js.map